import client from '../client';

const PATH = '/features'

/**
 * Create a new feature.
 * @param {Object} params
 * @param {String} params.name The name of the new feature to create.
 * @param {Number} params.classification The id of the classification where this feature belongs.
 */
export async function create({ name, classification } = {}) {
  return client.post(PATH, { name, classification }).then(({ data }) => data)
}

/**
 * Get all the features of the given classification.
 * @param {Number} classification The id of the classification to get its features. 
 */
export async function get(classification) {
  return client.get(PATH, { params: { classification } }).then(({ data }) => data)
}

/**
 * DEPRECATED.
 * Get a feature object with {id, name, values: String[]}.
 * @param {Number} id the id of the feature to get.
 */
export async function getById(id) {
  return client.get(`${PATH}/${id}`).then(({ data }) => data)
}

/**
 * Get the distinct values of the feature used in the past.
 * @param {Number} id the id of the feature to get.
 */
export async function getDistinctValues(id) {
  return client.get(`${PATH}/${id}/values`).then(({ data }) => data)
}

/**
 * Remove a feature from the database.
 * @param {Object} params
 * @param {Number} id the id of the feature to delete
 */
export async function remove({ id }) {
  return client.delete(`${PATH}/${id}`)
}

export default {
  create,
  get,
  getById,
  getDistinctValues,
  remove
}